import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae07f200"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "citation" }
const _hoisted_2 = { id: "profil" }
const _hoisted_3 = { class: "stack-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "home",
    ref: "resizeElement",
    class: _normalizeClass(["text", { light: !_ctx.darkMode, hasScrollBar: _ctx.hasScrollBar }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("home.citation")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("home.profil")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stacks, (stackList, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "stack-container",
        key: index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["title", { light: !_ctx.darkMode }])
        }, _toDisplayString(_ctx.$t("home." + stackList.name)), 3),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stackList.stackList, (stack, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["stack", { light: !_ctx.darkMode }]),
              key: index
            }, _toDisplayString(_ctx.getStackDisplayName(stack)), 3))
          }), 128))
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      id: "resume",
      class: _normalizeClass({ light: !_ctx.darkMode }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPDF && _ctx.openPDF(...args))),
      "aria-label": "Download Resume"
    }, " ↓ " + _toDisplayString(_ctx.$t("home.resume")), 3)
  ], 2))
}